import Common from "../../../Common"

interface CreateBody {
	pbx_user_id: id
}

export interface CompanyWallboardTokenCreateResponse {
	id: string
	token: string
}

const Token = class extends Common {
	browse = (companyId: id): CustomResponse<CompanyWallboardToken[]> =>
		this.get(`/company/${companyId}/wallboard/token`)

	read = (companyId: id, tokenId: id): CustomResponse<CompanyWallboardToken> =>
		this.get(`/company/${companyId}/wallboard/token/${tokenId}`)

	create = (companyId: id, data: CreateBody): CustomResponse<CompanyWallboardTokenCreateResponse> =>
		this.post(`/company/${companyId}/wallboard/token`, data)

	delete = (companyId: id, tokenId: id) =>
		this.doDelete(`/company/${companyId}/wallboard/token/${tokenId}`)
}

export default Token
